// extracted by mini-css-extract-plugin
module.exports = {"sr_only":"_2ZeR2y6-"};